import { loadResourcePath } from "path/middleware"

const loadMessageContext = (location) => {
  const { cohortId, userId } = location.match.params
  const messageStore = window.App.getStore("message")
  let context = { offering: parseInt(cohortId) }
  if (userId) context.to_users = [parseInt(userId)]
  messageStore.action.loadMessageContext(context).promise
  loadResourcePath(location) // TODO: won't need once context comes back with cohortId id
}

const clearMessageContext = (location) => {
  const messageStore = App.getStore("message")
  messageStore.reset()
}

export { clearMessageContext, loadMessageContext }
